import React from "react";
import { Link } from "react-router-dom";

import { projects } from "../data";
import styles from "../styles/components/ProjectIntegration.module.css";

const ProjectIntegration = ({ projectID }) => {
    const project = projects.find((p) => p.id === projectID);

    if (!project) {
        return <div>Project not found</div>;
    }

    return (
        <Link
            className={styles.projectIntegration}
            to={"/project/" + project.link}
        >
            <img
                className={styles.project}
                src={project.image}
                alt={project.name}
            ></img>
            <div className={styles.projectInfo}>
                <p className={styles.projectName}>{project.name}</p>
                <p className={styles.projectDescription}>
                    {project.description}
                </p>
            </div>
        </Link>
    );
};

export default ProjectIntegration;
